import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials: true so the browser sends/receives the httpOnly session cookie
// alongside requests. We keep the Authorization header interceptor (see AuthContext)
// during the 30-day cookie cutover window so any client that still has a Bearer
// token in localStorage keeps working until they sign in again.
export const api = axios.create({ baseURL: API, withCredentials: true });

export const fileUrl = (urlOrPath) => {
    if (!urlOrPath) return "";
    if (urlOrPath.startsWith("http")) return urlOrPath;
    if (urlOrPath.startsWith("/api/")) return `${BACKEND_URL}${urlOrPath}`;
    return urlOrPath;
};
